export default __webpack_public_path__ + "static/media/3DPrinting_07.1bc9a158.png";